import { render, staticRenderFns } from "./ValidVerPrescricao.vue?vue&type=template&id=58eb27fe&"
import script from "./ValidVerPrescricao.vue?vue&type=script&lang=js&"
export * from "./ValidVerPrescricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports